var module = void 0, exports = void 0, define = void 0;
import "jquery";

const globalJQuery = window.jQuery || window.$;

if (!globalJQuery) {
  throw new Error("jQuery failed to load");
}

window.jQuery = globalJQuery;
window.$ = globalJQuery;

export default globalJQuery;
